import { useQuery } from '@apollo/client'
import { FunctionComponent, useState } from 'react'
import { ListReviews, Loader } from '../../../components'
import {
  GET_CREATOR_RATINGS_BY_CREATOR_UUID,
  QueryGetCreatorRatingsByCreatorUuid,
} from '../../../gql'
import { Creator } from '../../../gql/types'

interface IProps {
  creatorUuid: string
  creator: Creator
}

const CreatorReviewsPublic: FunctionComponent<IProps> = ({
  creatorUuid,
  creator,
}) => {
  const limit = 12
  const [skip, setSkip] = useState(0)

  const { loading, error, data } =
    useQuery<QueryGetCreatorRatingsByCreatorUuid>(
      GET_CREATOR_RATINGS_BY_CREATOR_UUID,
      {
        variables: {
          creatorUuid,
          skip,
          limit,
        },
      },
    )

  const setPage = (page: number) => {
    setSkip(page * limit)
  }

  // Log error for debugging
  if (error) {
    console.log(
      'error GET_CREATOR_RATINGS_PUBLIC_BY_CREATOR_UUID',
      error.message,
    )
  }

  const ratings = data?.getCreatorRatingsByCreatorUuid?.items

  return (
    <div>
      {loading && <Loader />}
      {error && (
        <div className='text-red-500 my-4 p-4 bg-red-50 rounded-md'>
          <p>There has been an error. Try refreshing the page</p>
        </div>
      )}
      {!loading && !error && (
        <ListReviews
          ratings={ratings?.map((rating) => ({
            id: `${rating.id}`,
            name: rating.brand.name,
            profilePicUrl: rating.brand.logo?.url,
            url: rating.brand.website,
            stars: rating.stars,
            review: rating.review,
            createdAt: rating.createdAt,
            avatarType: 'brand',
          }))}
          pagination={data?.getCreatorRatingsByCreatorUuid?.pagination}
          setPage={setPage}
          className='mt-1 shadow-none'
        />
      )}
    </div>
  )
}

export { CreatorReviewsPublic }
